import { render } from "./StepReviewAndSubmit.vue?vue&type=template&id=68e50184"
import script from "./StepReviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./StepReviewAndSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__